// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ScriptsDocumentsV2FillablePdfPdfFileData {
    static getAttributeTypeMap() {
        return ScriptsDocumentsV2FillablePdfPdfFileData.attributeTypeMap;
    }
}
ScriptsDocumentsV2FillablePdfPdfFileData.discriminator = undefined;
ScriptsDocumentsV2FillablePdfPdfFileData.additionalProperties = false;
ScriptsDocumentsV2FillablePdfPdfFileData.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "value",
        "baseName": "value",
        "type": "string"
    },
];
//# sourceMappingURL=scriptsDocumentsV2FillablePdfPdfFileData.js.map